export const environment = {
  production: false,
  //csibefrontend: "http://localhost:8080/csibefrontend/",
  csibefrontend: "https://focus-qa.roarinc.com/csibefrontend/",
  // @ts-ignore
  csionlinereputationmax_tenant: "stellantis",
  csionlinereputationmax_google: "google",
  assets: "assets/",
  featureFlags: {
    ssoManagement: true,
    ssoHarmonization: true,
    maintenanceBanner: true
  }

};